import { globalHelperFunctions } from './src/functions/global-functions'
import * as globalDateFunctions from './src/functions/global-date-functions'
import { useCommandId } from './src/vue/composables/useCommandId'
import { useDateNowInterval } from './src/vue/composables/useDateNowInterval'
import { useDebounceFn } from './src/vue/composables/useDebounceFn'
import { useDisplay } from './src/vue/composables/useDisplay'
import { useLoading } from './src/vue/composables/useLoading'
import { useLocalStorage } from './src/vue/composables/useLocalStorage'
import { useResizeObserver } from './src/vue/composables/useResizeObserver'
import { useTheme } from './src/vue/composables/useTheme'
import { useWindowSize } from './src/vue/composables/useWindowSize'
import { useDetachedKeyboardNavigation } from './src/vue/composables/useDetachedKeyboardNavigation'
import { useDebouncedSearchInput } from './src/vue/composables/useDebouncedSearchInput'

export * from './src/vue/composables/useAppStateProvider'
export * from './src/vue/composables/useCommandId'
export { useFormatting } from './src/vue/composables/useFormatting'
export * from './src/functions/format-standalone'
export * from './src/functions/normalize-time-string'
export * from './src/functions/parse-date-input'
export * from './src/functions/promise-utils'

export { type ElementPosition } from './src/functions/global-functions'
export { combineLocalDateTimeToInstant } from './src/functions/global-date-functions'

export const globalUtils = {
  composables: {
    useTheme,
    useLocalStorage,
    useDisplay,
    useWindowSize,
    useResizeObserver,
    useDebounceFn,
    useCommandId,
    useDateNowInterval,
    useLoading,
    useDetachedKeyboardNavigation,
    useDebouncedSearchInput
  },
  functions: globalHelperFunctions,
  date: globalDateFunctions
}

export {
  useDebounceFn,
  useDisplay,
  useDateNowInterval,
  useLocalStorage,
  useLoading
}
